import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { ArrowLeft, Clock } from "lucide-react";
import { api } from "../../lib/api";
import { useI18n } from "../../context/LanguageContext";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function BlogPost() {
  const { slug } = useParams();
  const { t } = useI18n();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-32 pb-28" data-testid="blog-post-page">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
            <ArrowLeft className="w-4 h-4" /> {t("blog.back")}
          </Link>
        </div>
        {post === undefined ? (
          <div className="max-w-3xl mx-auto px-6 mt-10 font-mono-x text-primary tracking-widest animate-pulse">LOADING…</div>
        ) : post === null ? (
          <div className="max-w-3xl mx-auto px-6 mt-10 text-muted-foreground">Post not found.</div>
        ) : (
          <article className="max-w-3xl mx-auto px-6 mt-8">
            <div className="flex flex-wrap gap-2 mb-4">
              {(post.tags || []).map((tag) => <span key={tag} className="font-mono-x text-[10px] tracking-widest text-primary border border-primary/30 rounded-full px-2 py-0.5">{tag}</span>)}
            </div>
            <h1 className="font-heading font-extrabold tracking-tighter text-4xl md:text-5xl leading-[1.05]">{post.title}</h1>
            <div className="mt-5 flex items-center gap-4 text-sm text-muted-foreground">
              <span>{post.author}</span>
              <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {post.read_minutes} {t("blog.read")}</span>
              {post.published_at && <span>{new Date(post.published_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}</span>}
            </div>
            {post.cover_image && <img src={post.cover_image} alt={post.title} className="mt-8 w-full h-72 md:h-96 object-cover rounded-2xl border border-border" />}
            <div className="blog-content mt-10" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content || "") }} />
          </article>
        )}
      </main>
      <Footer />
    </div>
  );
}
